import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function Callout() {
  return {
    init: () => {
      const callout = document.querySelector('.w-callout');
      if (!callout) return;

      window.addEventListener(
        'scroll',
        () => {
          if (window.scrollY > 80) {
            document.documentElement.classList.add('w-has-callout-visible');
          } else {
            document.documentElement.classList.remove('w-has-callout-visible');
          }
        },
        { passive: true }
      );
    },
  };
}
